import { render, staticRenderFns } from "./PointItemPreview.vue?vue&type=template&id=204218d4&scoped=true&"
import script from "./PointItemPreview.vue?vue&type=script&lang=js&"
export * from "./PointItemPreview.vue?vue&type=script&lang=js&"
import style0 from "./PointItemPreview.vue?vue&type=style&index=0&id=204218d4&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204218d4",
  null
  
)

export default component.exports